<template>
  <div class="tank-wrapper">
    <!-- DAILY USAGE CHART -->
    <!-- <div class="row justify-content-around mt-3 dashboard_second_row_right"> -->

    <!-- LOADER -->
    <div
      class="showLoaderDiv charts__loader w-full mx-auto"
      style="width: 90%; height: 100%"
      v-if="showLoader"
    >
      <div :class="showLoader ? 'loading' : null"></div>
    </div>
    <!-- END LOADER -->
    <div
      class="dashboard_chart mt-5 mx-auto align-items-center mb-3"
      style="width: 90%; border-radius: 10px"
    >
      <div class=" ">
        <highcharts
          :options="tankVolumeChart"
          class=""
          style="padding-top: 60px"
        ></highcharts>
      </div>
    </div>
    <!-- </div> -->

    <!-- TABLE -->
    <section class="bg-white rounded table-section my-20">
      <h3 class="py-3">{{ $t("text.iGroup.tanksLessThan") }}</h3>
      <ejs-grid
        v-show="!showLoader"
        ref="dataGrid"
        :created="refreshGrid"
        :allowPaging="true"
        :allowSorting="true"
        :pageSettings="pageSettings"
        :toolbar="toolbar"
        :searchSettings="search"
        :allowExcelExport="true"
        :allowPdfExport="true"
        :toolbarClick="toolbarClick"
        :locale="usedLang"
      >
        <e-columns>
          <e-column width="40" field="index" headerText="#"></e-column>
          <!-- <e-column field="date" width="180" headerText="Date"></e-column> -->
          <e-column
            :template="tankName"
            width="180"
            :headerText="$t('text.iBranchTank.tank')"
          ></e-column>
          <e-column
            field="branchName"
            width="180"
            :headerText="$t('text.iBranchTank.site')"
          ></e-column>
          <e-column
            field="currentVolume"
            width="180"
            :headerText="$t('text.iBranchTank.currVolume')"
          ></e-column>
          <e-column
            field="maxCapacity"
            width="180"
            :headerText="$t('text.iBranchTank.maxCapacity')"
          ></e-column>
        </e-columns>
      </ejs-grid>
      <TableLoader :showLoader="showLoader" />
    </section>
  </div>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import tankName from "@/components/TableTemplates/IndustrialAdmin/tankName.vue";
import tankAction from "@/components/TableTemplates/IndustrialAdmin/tankActionGroup.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
export default {
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  props: ["maxDate", "dateRange", "startDatee", "endDatee"],
  components: {
    GroupMasterLayout,
    Highcharts: Chart,
    TableLoader,
    PulseLoader,
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
      }
      this.getCompanyPowerUsetankVolume();
    },
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      groupID: this.$route.query.groupID,
      companyCumulativeWallet: null,
      showLoader: false,
      isDisabled: true,
      tankStartDate: this.$moment().format("MMMM D, YYYY"),
      startDate: this.startDatee,
      endDate: this.endDatee,
      pageSettings: { pageSizes: [12, 50, 100, 200], pageCount: 4 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      tankDateRange: this.tankStartDate,
      hourlyPoweerConsumptionDateRange: this.hourlyConsumptionStartDate,
      totalGenHours: 0,
      totalPgHours: 0,
      tanks: [],
      consumptionstatus: "daily",
      year: "2020",
      tankName: function () {
        return {
          template: tankName,
        };
      },
      tankAction: function () {
        return {
          template: tankAction,
        };
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],

      tankVolumeChart: {
        title: {
          text: "Tank Volume Chart",
        },
        chart: {
          height: "50%",
          type: "column",
        },

        xAxis: {
          categories: [],
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Volume",
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
          },
        },
        series: [],
      },
    };
  },
  created() {
    this.getTanks();

    this.getCompanyPowerUsetankVolume();
  },
  methods: {
    changeConsumptionStatus(e) {
      if (e.target.value === "hourly") {
        this.consumptionstatus = "hourly";
      } else if (e.target.value === "daily") {
        this.consumptionstatus = "daily";
      } else {
        this.consumptionstatus = "monthly";
      }
    },
    changeYear(e) {
      this.year = e.target.value;
      this.getMonthlyUsageChart();
    },

    getTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Group/TanksLessThan30/${this.groupID}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          let index = 0;
          res.data.forEach((el) => {
            index++;
            el.index = index;
            el.currentVolume = el.currentVolume.toFixed(2);
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
        });
    },

    getCompanyPowerUsetankVolume() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/GroupTankConsumption/${this.groupID}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.forEach((x) => {
            let date = new Date(x.date);

            const newDate = this.$moment(date).format("MMMM D");
            x.date = newDate;
          });

          let volumeConsumed = res.data.map((el) => {
            return Number(el.volumeSold.toFixed(2));
          });
          let volumeFilled = res.data.map((el) => {
            return Number(el.volumeFilled.toFixed(2));
          });

          let cats = [];
          res.data.forEach((el) => {
            cats.push(el.tankName);
          });
          let filledSeries = [
            {
              name: "Volume filled",
              data: volumeFilled,
              color: "#FCD462",
            },
          ];

          let consumedSeries = [
            {
              name: "Volume Consumed",
              data: volumeConsumed,
              color: "#370F70",
            },
          ];

          this.tankVolumeChart.series = [...filledSeries, ...consumedSeries];
          this.tankVolumeChart.xAxis.categories = cats;
        })
        .catch((error) => {});
    },

    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
  .dashboard_chart {
    height: 300px;
  }
}

.tank-wrapper {
  width: 95%;
  margin: auto auto;
}
wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}
</style>
